import { render, staticRenderFns } from "./product-tags.vue?vue&type=template&id=5154851c&scoped=true"
import script from "./product-tags.vue?vue&type=script&lang=ts"
export * from "./product-tags.vue?vue&type=script&lang=ts"
import style0 from "./product-tags.vue?vue&type=style&index=0&id=5154851c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5154851c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5154851c')) {
      api.createRecord('5154851c', component.options)
    } else {
      api.reload('5154851c', component.options)
    }
    module.hot.accept("./product-tags.vue?vue&type=template&id=5154851c&scoped=true", function () {
      api.rerender('5154851c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/product-tags.vue"
export default component.exports